app.controller("surgeryWaitlistController", [
    "$scope",
    "$state",
    "$modal",
    "$mdDialog",
    "Session",
    "currentUser",
    "CurrentPatient",
    "PatientAPI",
    "SurgeryWaitlistAPI",
    "$timeout",
    "ShareData",
    "allSurgeryWaitlists",
    "TIMEZONE_TYPE",
    "PRACTICE_PALETTE",
    "countryConfig",
    "AppointmentAPI",
    "$animate",
    "$element",
    function (
        $scope, $state, $modal, $mdDialog,
        Session, currentUser, CurrentPatient,
        PatientAPI, SurgeryWaitlistAPI, $timeout, ShareData,
        allSurgeryWaitlists, TIMEZONE_TYPE, PRACTICE_PALETTE, countryConfig, AppointmentAPI,
        $animate, $element) {

        // ngAnimate holds an ng-class change for as long as any CSS animation it finds on the element, and
        // the spinner a step shows while it saves spins without end, so the icon was left between its
        // spinner and its tick until the dialog was opened again. Nothing in here animates through
        // ngAnimate; what fades does so with plain CSS.
        $animate.enabled(angular.element($element[0].querySelector(".settings-shell") || $element[0]), false);

        // Rows drawn at a time; more are added as the end of the table scrolls into view.
        const PAGE_SIZE = 60;

        // Where an entry is on its way to surgery, in order.
        // Pre-approval, ticked on and off on each row. Surgery completed has its own button.
        $scope.PREAPPROVAL_STEPS = [
            { field: "preapproval_submitted", date: "preapproval_submission_date_UTC", label: "Submit", name: "Pre-approval submitted" },
            { field: "preapproval_completed", date: "preapproval_completion_date_UTC", label: "Complete", name: "Pre-approval completed" },
        ];

        $scope.currentUser = currentUser;
        // NHI only exists in NZ; AU patients have none to search on.
        $scope.waitlistSearchPlaceholder = countryConfig.nhiFeatureEnabled
            ? "Find patient, NHI, procedure, surgeon or funding"
            : "Find patient, procedure, surgeon or funding";
        $scope.CurrentPatient = CurrentPatient;

        $scope.surgeryWaitlistAPI = SurgeryWaitlistAPI;
        $scope.patientAPI = PatientAPI;
        $scope.ShareData = ShareData;

        $scope.allSurgeryWaitlistViewData = [];

        $scope.$mdDialog = $mdDialog;

        $scope.TIMEZONE_TYPE = TIMEZONE_TYPE;

        // Every practice the user belongs to, not just the tasks-enabled ones: the waitlist button has
        // no tasks gate, so filtering on it left a tasks-less practice with an empty list.
        $scope.practiceOptions = Session.practiceOptions;

        const saved = $scope.ShareData.waitlistFilters;

        // Opened, the list is the practice being worked in, and everyone's patients there: a practice or
        // surgeon picked last time is not kept. find() returning undefined used to put [undefined] in the
        // list, which threw on p.id the moment the list was filtered by practice.
        const currentPractice = $scope.practiceOptions.find(t => t.id === Session.practice.id);
        $scope.selectedPractice = currentPractice ? [currentPractice] : [];

        $scope.view = {
            tab: saved.tab || "waiting",
            search: saved.search || "",
            surgeon: "",
            booking: saved.booking || "",
            // overdue, soon or asap; empty for any
            timeframe: saved.timeframe || "",
        };
        // Oldest first, with the user's own patients ahead of everyone else's until a column is sorted.
        $scope.sort = { key: "waitlisted", desc: false, mineFirst: true };
        $scope.rows = [];
        $scope.counts = { waiting: 0, done: 0, booked: 0, unbooked: 0 };
        $scope.surgeons = [];
        $scope.shown = PAGE_SIZE;
        $scope.notice = null;
        // Rows saving from the list, and rows just marked done that linger before moving, by row key
        $scope.rowBusy = {};
        $scope.settling = {};
        // Rows whose surgery date just saved, for the tick on the date button; and, in a browser that can't
        // open its date picker from a button, rows showing the date input itself instead
        $scope.rowSaved = {};
        $scope.typingDate = {};
        // The comment being written on the list (one at a time), and rows whose comment just saved
        $scope.commentEdit = null;
        $scope.commentSaved = {};
        $scope.$on('waitlist:updateAllSurgeryWaitlists', ($event, surgeryWaitlists) => {
            updateSurgeryWaitlistData(surgeryWaitlists)
            rebuildList();
        });

        this.$onInit = function () {
            updateSurgeryWaitlistData(allSurgeryWaitlists || []);
            rebuildList();
        }

        function mapToSurgeryWaitlistViewInfo(surgeryWaitlistViewInfo, laterality) {
            let procedure = {}
            if (surgeryWaitlistViewInfo.primary_procedure_od != null && laterality === "OD") {
                procedure = surgeryWaitlistViewInfo.primary_procedure_od;
            }
            else if (surgeryWaitlistViewInfo.primary_procedure_os != null && laterality === "OS") {
                procedure = surgeryWaitlistViewInfo.primary_procedure_os;
            } else {
                return null
            }
            let waitlistLaterality = procedure.laterality;

            let preapproval_submission_date = surgeryWaitlistViewInfo.preapproval_submission_date_UTC_map[waitlistLaterality];
            let preapproval_completion_date = surgeryWaitlistViewInfo.preapproval_completion_date_UTC_map[waitlistLaterality];
            let surgery_start_date = surgeryWaitlistViewInfo.surgery_start_date_UTC_map[waitlistLaterality];
            let surgery_completion_date = surgeryWaitlistViewInfo.surgery_completion_date_UTC_map[waitlistLaterality];

            let surgeryWaitlist = {
                surgery_waitlist_id: surgeryWaitlistViewInfo.surgery_waitlist_id,
                surgeon_full_name: surgeryWaitlistViewInfo.created_by_user_full_name,
                // Who the entry is with. Only a server new enough to change it sends it, and only then is
                // it offered for changing.
                created_by_user_id: surgeryWaitlistViewInfo.created_by_user_id,
                surgery_waitlist_creation_date: surgeryWaitlistViewInfo.date_created,

                practice_id: surgeryWaitlistViewInfo.practice_id,

                patient_id: surgeryWaitlistViewInfo.patient_id,
                patient_full_name: surgeryWaitlistViewInfo.patient_full_name,
                patient_nhi: surgeryWaitlistViewInfo.patient_nhi,

                procedure: procedure,
                laterality: procedure.laterality,
                procedure_type: procedure.snomed_concept.pt.term,

                // The eye's own comments. Kept empty rather than filled with a placeholder: every update sends
                // this back, so a placeholder here was saved as though someone had written it.
                comments: eyeComments(surgeryWaitlistViewInfo, waitlistLaterality),
                funding: surgeryWaitlistViewInfo.funding,

                // When surgery should be, as asked for on the entry; absent on older entries
                preferred_timeframe_type: surgeryWaitlistViewInfo.preferred_timeframe_type || null,
                timeframe_number_of_weeks: surgeryWaitlistViewInfo.timeframe_number_of_weeks || null,
                timeframe_after_date_UTC: surgeryWaitlistViewInfo.timeframe_after_date_UTC || null,
                timeframe_before_date_UTC: surgeryWaitlistViewInfo.timeframe_before_date_UTC || null,

                preapproval_submission_date_UTC: preapproval_submission_date ?? null,
                preapproval_submitted: (preapproval_submission_date != null),

                preapproval_completion_date_UTC: preapproval_completion_date ?? null,
                preapproval_completed: (preapproval_completion_date != null),

                surgery_start_date_UTC: $scope.mapUTCDateToLocal(surgery_start_date) ?? "",
                surgery_start_date_raw: surgery_start_date ? moment(surgery_start_date).valueOf() : 0,

                surgery_completion_date_UTC: surgery_completion_date ?? null,
                surgery_completed: (surgery_completion_date != null),
            }

            return surgeryWaitlist
        }

        function practiceTimezoneName() {
            // A practice with no (or an unrecognised) timezone used to throw here and break the whole list.
            var practiceTimezone = $scope.TIMEZONE_TYPE.find(zone => zone.value === Session.practice.timezone);
            var name = practiceTimezone && practiceTimezone.name;
            return name && moment.tz.zone(name) ? name : null;
        }

        // Another of the user's practices' timezone, or the one being worked in's when it has none
        function timezoneOfPractice(practiceId) {
            const practice = ($scope.practiceOptions || []).find(p => p.id === practiceId);
            const zone = practice && $scope.TIMEZONE_TYPE.find(z => z.value === practice.timezone || z.name === practice.timezone);
            const name = zone ? zone.name : practice && practice.timezone;
            return name && moment.tz.zone(name) ? name : practiceTimezoneName();
        }

        $scope.mapUTCDateToLocal = function (UTCDate, format) {
            if (UTCDate == null || UTCDate == '') return null;

            var zone = practiceTimezoneName();
            if (!zone) {
                return null;
            }
            return moment.utc(UTCDate).tz(zone).format(format || "DD/MM/YYYY");
        }

        $scope.formatDate = function (UTCDate) {
            return $scope.mapUTCDateToLocal(UTCDate, "D MMM YYYY");
        };

        // A surgery date as the date picker holds it (DD/MM/YYYY), as the list shows dates.
        function displayLocalDate(value) {
            return value ? moment(value, "DD/MM/YYYY").format("D MMM YYYY") : "";
        }

        function isMine(waitlist) {
            if (waitlist.created_by_user_id != null) {
                return waitlist.created_by_user_id === $scope.currentUser.id;
            }
            return waitlist.surgeon_full_name == `${$scope.currentUser.title} ${$scope.currentUser.firstName} ${$scope.currentUser.lastName}`;
        }

        function rowKey(waitlist) {
            return waitlist.surgery_waitlist_id + ":" + waitlist.laterality;
        }

        // Comments are kept per eye. An entry commented on before they were shows that comment on each of its
        // eyes until one eye's comments are saved, when the server moves it onto the eyes.
        function eyeComments(surgeryWaitlistViewInfo, laterality) {
            const commentsMap = surgeryWaitlistViewInfo.comments_map || {};
            const comments = laterality in commentsMap ? commentsMap[laterality] : surgeryWaitlistViewInfo.comments;
            return comments || null;
        }

        // How long an entry has waited, in days: until its surgery once done, until today otherwise.
        function waitedDays(waitlist) {
            const from = moment(waitlist.surgery_waitlist_creation_date);
            const to = waitlist.surgery_completed && waitlist.surgery_completion_date_UTC ? moment(waitlist.surgery_completion_date_UTC) : moment();
            return Math.max(0, to.diff(from, "days"));
        }

        function waitedFor(waitlist) {
            const days = waitedDays(waitlist);
            if (days < 14) {
                return days === 1 ? "1 day" : days + " days";
            }
            if (days < 7 * 13) {
                return Math.floor(days / 7) + " weeks";
            }
            const months = Math.floor(days / 30.44);
            return months + " months";
        }

        // The next thing to happen, in words, for the list's progress column.
        function stageOf(waitlist) {
            if (waitlist.surgery_completed) {
                return "Surgery completed";
            }
            if (waitlist.preapproval_completed) {
                return waitlist.surgery_start_date_UTC ? "Booked" : "Ready to book";
            }
            if (waitlist.preapproval_submitted) {
                return "Awaiting pre-approval";
            }
            return "Pre-approval to submit";
        }

        // =================================================================
        // Preferred timeframe: what was asked for, the date surgery should be booked by, and how the eye
        // stands against it. "Within N weeks" counts from the day the entry was made.
        // =================================================================
        // Worst first, for the entry's cell and the filter: overdue, then due soon, ASAP, on track, not yet open
        const TIMEFRAME_RANK = { late: 0, soon: 1, asap: 2, ok: 3, range: 4, done: 5 };
        const DUE_SOON_DAYS = 7;
        // The rail's Timeframe filters, by the status each picks out
        const TIMEFRAME_FILTERS = { overdue: "late", soon: "soon", asap: "asap" };

        function daysWord(days) {
            return days === 1 ? "1 day" : days + " days";
        }

        function timeframeOf(row) {
            const type = row.preferred_timeframe_type;
            const created = moment(row.surgery_waitlist_creation_date).startOf("day");
            let label;
            let due;
            let opens = null;

            if (type === "ASAP") {
                label = "ASAP";
                due = created;
            } else if (type === "WEEKS" && row.timeframe_number_of_weeks) {
                const weeks = row.timeframe_number_of_weeks;
                label = "Within " + weeks + (weeks === 1 ? " week" : " weeks");
                due = created.clone().add(weeks, "weeks");
            } else if (type === "DATES" && row.timeframe_before_date_UTC) {
                label = [$scope.mapUTCDateToLocal(row.timeframe_after_date_UTC, "D MMM"), $scope.mapUTCDateToLocal(row.timeframe_before_date_UTC, "D MMM")]
                    .filter(Boolean).join(" – ");
                due = moment.utc(row.timeframe_before_date_UTC).startOf("day");
                opens = row.timeframe_after_date_UTC ? moment.utc(row.timeframe_after_date_UTC).startOf("day") : null;
            } else {
                return null;
            }

            const dueLabel = due.format("D MMM");
            const today = moment().startOf("day");
            const tf = { type: type, label: label, dueRaw: due.valueOf() };

            // Done: whether surgery was inside the timeframe
            if (row.surgery_completed) {
                const doneOn = row.surgery_completion_date_UTC ? moment(row.surgery_completion_date_UTC).startOf("day") : today;
                const late = type !== "ASAP" && doneOn.diff(due, "days");
                tf.status = "done";
                tf.note = late > 0 ? "Done " + daysWord(late) + " after it" : type === "ASAP" ? "Done after " + daysWord(Math.max(0, doneOn.diff(created, "days"))) : "Done inside it";
                return tf;
            }

            if (type === "ASAP") {
                tf.status = "asap";
                const waited = today.diff(created, "days");
                tf.note = waited <= 0 ? "Waitlisted today" : "Waiting " + daysWord(waited);
                return tf;
            }

            // Booked: whether the date booked is inside the timeframe
            if (row.surgery_start_date_raw) {
                const booked = moment(row.surgery_start_date_raw).startOf("day");
                const after = booked.diff(due, "days");
                if (after > 0) {
                    tf.status = "late";
                    tf.note = "Booked " + daysWord(after) + " after " + dueLabel;
                } else if (opens && booked.isBefore(opens)) {
                    tf.status = "soon";
                    tf.note = "Booked before it opens";
                } else {
                    tf.status = "ok";
                    tf.note = "Book by " + dueLabel + " · booked inside it";
                }
                return tf;
            }

            const left = due.diff(today, "days");
            if (left < 0) {
                tf.status = "late";
                tf.note = "Book by " + dueLabel + " · " + daysWord(-left) + " overdue";
            } else if (opens && opens.isAfter(today)) {
                tf.status = "range";
                tf.note = "Opens in " + daysWord(opens.diff(today, "days"));
            } else if (left <= DUE_SOON_DAYS) {
                tf.status = "soon";
                tf.note = "Book by " + dueLabel + " · " + (left === 0 ? "due today" : daysWord(left) + " left");
            } else {
                tf.status = "ok";
                tf.note = "Book by " + dueLabel;
            }
            return tf;
        }

        function updateSurgeryWaitlistData(waitlistMap) {
            $scope.allSurgeryWaitlistViewData = waitlistMap.flatMap(sugeryWaitlistViewInfo => {
                let out = []

                if (sugeryWaitlistViewInfo.primary_procedure_od) {
                    let surgeryWaitlistView = mapToSurgeryWaitlistViewInfo(sugeryWaitlistViewInfo, "OD")
                    if (surgeryWaitlistView)
                        out.push(surgeryWaitlistView)
                }

                if (sugeryWaitlistViewInfo.primary_procedure_os) {
                    let surgeryWaitlistView = mapToSurgeryWaitlistViewInfo(sugeryWaitlistViewInfo, "OS")
                    if (surgeryWaitlistView)
                        out.push(surgeryWaitlistView)
                }

                return out;
            });
        }

        // =================================================================
        // The list: tab, filters and sort
        // =================================================================
        function compareText(a, b) {
            return String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });
        }

        function compareDates(a, b) {
            return new Date(a) - new Date(b);
        }

        // The list's sorts, on patients: each patient sorts by their first entry, and by the earliest
        // surgery date of the eyes still waiting
        const SORTS = {
            waitlisted: (a, b) => compareDates(a.waitlisted, b.waitlisted),
            patient: (a, b) => compareText(a.lead.patient_full_name, b.lead.patient_full_name),
            procedure: (a, b) => compareText(a.lead.procedure_type, b.lead.procedure_type),
            surgeon: (a, b) => compareText(a.lead.surgeon_full_name, b.lead.surgeon_full_name),
            funding: (a, b) => compareText(a.lead.funding, b.lead.funding),
            surgery: (a, b) => a.surgeryRaw - b.surgeryRaw,
            // The date surgery should be booked by, soonest first
            timeframe: (a, b) => a.dueRaw - b.dueRaw,
        };

        function matchesSearch(row, term) {
            if (!term) {
                return true;
            }
            return [row.patient_full_name, row.patient_nhi, row.procedure_type, row.funding, row.surgeon_full_name, row.comments]
                .some((text) => text && String(text).toLowerCase().indexOf(term) !== -1);
        }

        // One block per patient on each tab: their eyes still waiting on Waiting, and their eyes done on
        // Completed. A patient with both is on both, so nothing is hidden, and completing or reopening an eye
        // moves only that eye.
        function groupKey(row) {
            return (row.surgery_completed ? "done" : "waiting") + ":" + row.practice_id + ":" + row.patient_id;
        }

        function makeGroup(key, eyes) {
            const done = eyes[0].surgery_completed;
            eyes.forEach((eye) => {
                eye.$groupKey = key;
            });

            // The entries that have waited longest come first, the right eye before the left within one.
            const shown = eyes;
            const entryIds = shown.map(e => e.surgery_waitlist_id).filter((id, i, all) => all.indexOf(id) === i);
            const entries = entryIds.map((id) => {
                const entryEyes = shown.filter(e => e.surgery_waitlist_id === id)
                    .sort((a, b) => (a.laterality === b.laterality ? 0 : a.laterality === "OD" ? -1 : 1));
                return { id: id, eyes: entryEyes, waited: Math.max(...entryEyes.map(waitedDays)) };
            }).sort((a, b) => b.waited - a.waited
                || compareDates(a.eyes[0].surgery_waitlist_creation_date, b.eyes[0].surgery_waitlist_creation_date)
                || compareText(a.id, b.id));

            // Each eye, with its comment line under it - funding belongs to the entry, comments to the eye. The
            // eye's own cells span its comment line, and the entry's span all of its eyes' lines. A finished eye
            // with no comments has nothing to show there.
            const lines = [];
            entries.forEach((entry, entryIndex) => {
                entry.eyes.forEach((eye) => {
                    eye.$lineSpan = !eye.$entryDone || eye.comments ? 2 : 1;
                });
                const entrySpan = entry.eyes.reduce((sum, eye) => sum + eye.$lineSpan, 0);
                // The timeframe belongs to the entry: its cell shows how the worse of its eyes stands
                const entryTimeframe = entry.eyes.map(e => e.$timeframe).filter(Boolean)
                    .sort((a, b) => TIMEFRAME_RANK[a.status] - TIMEFRAME_RANK[b.status])[0] || null;
                entry.eyes.forEach((eye, i) => {
                    eye.$entryFirst = i === 0;
                    eye.$entrySpan = entrySpan;
                    eye.$entryTimeframe = entryTimeframe;
                    // A hairline between one entry and the next
                    eye.$entryStart = i === 0 && entryIndex > 0;
                    lines.push({ key: eye.$key, eye: eye });
                    if (eye.$lineSpan === 2) {
                        lines.push({ key: eye.$key + ":comments", comment: eye });
                    }
                });
            });
            const ordered = entries.reduce((all, entry) => all.concat(entry.eyes), []);

            // Booking the second eye for the first eye's day: offered while it is unbooked, and noted once it is
            eyes.forEach((eye) => {
                const other = eyes.find(e => e !== eye && e.laterality !== eye.laterality && !e.surgery_completed);
                const waiting = !!other && !eye.surgery_completed;
                eye.$sameDayOffer = waiting && !eye.surgery_start_date_UTC && other.surgery_start_date_UTC ? other : null;
                eye.$sameDayAs = waiting && eye.surgery_start_date_UTC && eye.surgery_start_date_UTC === other.surgery_start_date_UTC
                    && ordered.indexOf(other) < ordered.indexOf(eye) ? other : null;
            });

            const dates = ordered.map(e => e.surgery_start_date_raw).filter(Boolean);
            const dues = ordered.map(e => e.$timeframe && e.$timeframe.dueRaw).filter(Boolean);
            return {
                key: key,
                eyes: eyes,
                shown: ordered,
                lines: lines,
                lead: ordered[0],
                done: done,
                unbooked: !done && ordered.some(e => !e.surgery_start_date_UTC),
                mine: ordered.some(e => e.$mine),
                // The patient's longest wait, for the Waitlisted sort
                waitlisted: ordered.map(e => e.surgery_waitlist_creation_date).sort(compareDates)[0],
                surgeryRaw: dates.length ? Math.min(...dates) : 0,
                // The soonest date any of the patient's eyes should be booked by; none sorts last
                dueRaw: dues.length ? Math.min(...dues) : Number.MAX_SAFE_INTEGER,
                // How the patient's eyes stand against their timeframes, for the Timeframe filter
                timeframeStatuses: ordered.map(e => e.$timeframe && e.$timeframe.status).filter(Boolean),
            };
        }

        // Everything the list draws is worked out here, once per change, rather than by functions the
        // template would call on every digest. The nav re-broadcasts the whole list whenever anyone in
        // the practice edits an entry, so this also runs on other people's changes - nothing here resets
        // the reader's place, sort or filters.
        function rebuildList() {
            const inPractices = $scope.allSurgeryWaitlistViewData
                .filter(waitlist => $scope.selectedPractice.some(p => p.id == waitlist.practice_id));

            inPractices.forEach((row) => {
                row.$key = rowKey(row);
                row.$mine = isMine(row);
                row.$waited = waitedFor(row);
                row.$stage = stageOf(row);
                row.$surgeryDate = displayLocalDate(row.surgery_start_date_UTC);
                // The date input's model is a Date
                row.$dateValue = row.surgery_start_date_UTC ? moment(row.surgery_start_date_UTC, "DD/MM/YYYY").toDate() : null;
                // The surgeon picker's. A change is written to the row before it saves (changeSurgeon), so the
                // picker can always follow the row - a fresh row from the server's reply included.
                row.$surgeonPick = row.created_by_user_id;
                row.$timeframe = timeframeOf(row);
            });

            // An entry with every eye done is finished with: its comments are kept, not changed. Worked out
            // across both tabs, as an entry's eyes can now be on different ones.
            const byEntry = {};
            inPractices.forEach(row => (byEntry[row.surgery_waitlist_id] = byEntry[row.surgery_waitlist_id] || []).push(row));
            inPractices.forEach((row) => {
                row.$entryDone = byEntry[row.surgery_waitlist_id].every(e => e.surgery_completed);
            });

            const byPatient = {};
            inPractices.forEach((row) => {
                const key = groupKey(row);
                (byPatient[key] = byPatient[key] || []).push(row);
            });
            const groups = Object.keys(byPatient).map(key => makeGroup(key, byPatient[key]));
            $scope.groupsByKey = {};
            groups.forEach(group => ($scope.groupsByKey[group.key] = group));

            // Counted by patient
            const waiting = groups.filter(group => !group.done);
            const done = groups.filter(group => group.done);
            const hasTimeframe = (group, status) => group.timeframeStatuses.indexOf(status) !== -1;
            $scope.counts = {
                waiting: waiting.length,
                done: done.length,
                booked: waiting.filter(group => !group.unbooked).length,
                unbooked: waiting.filter(group => group.unbooked).length,
                overdue: waiting.filter(group => hasTimeframe(group, "late")).length,
                dueSoon: waiting.filter(group => hasTimeframe(group, "soon")).length,
                asap: waiting.filter(group => hasTimeframe(group, "asap")).length,
            };
            const inTab = $scope.view.tab === "done" ? done : waiting;

            // The signed-in user is always among the surgeons, first, with nothing to their name if that is so -
            // by the name their own entries carry, so choosing them filters to those entries
            const surgeons = {};
            if ($scope.selectedPractice.length) {
                const mine = $scope.allSurgeryWaitlistViewData.find(w => isMine(w) && w.surgeon_full_name);
                const myName = mine ? mine.surgeon_full_name
                    : [$scope.currentUser.title, $scope.currentUser.firstName, $scope.currentUser.lastName].filter(Boolean).join(" ");
                surgeons[myName] = { name: myName, isMe: true, count: 0 };
            }
            inTab.forEach((group) => {
                const names = group.shown.map(e => e.surgeon_full_name || "").filter((name, i, all) => all.indexOf(name) === i);
                names.forEach((name) => {
                    if (!surgeons[name]) {
                        surgeons[name] = { name: name, isMe: group.shown.some(e => e.$mine && (e.surgeon_full_name || "") === name), count: 0 };
                    }
                    surgeons[name].count++;
                });
            });
            $scope.surgeons = Object.values(surgeons).sort((a, b) => {
                if (a.isMe !== b.isMe) return a.isMe ? -1 : 1;
                return compareText(a.name, b.name);
            });

            // The list itself is of patients
            const term = ($scope.view.search || "").trim().toLowerCase();
            const compare = SORTS[$scope.sort.key] || SORTS.waitlisted;
            const direction = $scope.sort.desc ? -1 : 1;
            $scope.rows = inTab
                .filter(group => !$scope.view.surgeon || group.shown.some(e => e.surgeon_full_name === $scope.view.surgeon))
                .filter(group => $scope.view.tab === "done" || !$scope.view.booking
                    || ($scope.view.booking === "booked") === !group.unbooked)
                .filter(group => $scope.view.tab === "done" || !$scope.view.timeframe
                    || hasTimeframe(group, TIMEFRAME_FILTERS[$scope.view.timeframe]))
                .filter(group => group.shown.some(e => matchesSearch(e, term)))
                .sort((a, b) => {
                    if ($scope.sort.mineFirst && a.mine !== b.mine) {
                        return a.mine ? -1 : 1;
                    }
                    // Unbooked patients go last in either direction, rather than first as "earliest".
                    if ($scope.sort.key === "surgery" && !a.surgeryRaw !== !b.surgeryRaw) {
                        return a.surgeryRaw ? -1 : 1;
                    }
                    // So do patients with no timeframe
                    const noDueA = a.dueRaw === Number.MAX_SAFE_INTEGER;
                    if ($scope.sort.key === "timeframe" && noDueA !== (b.dueRaw === Number.MAX_SAFE_INTEGER)) {
                        return noDueA ? 1 : -1;
                    }
                    return direction * compare(a, b) || SORTS.waitlisted(a, b);
                });
        }

        // An eye just completed or reopened moves to the other tab, so it fades first - its comments with it -
        // and the whole patient block fades when that was the block's last eye
        $scope.isGroupSettling = function (group) {
            return group.shown.every(e => $scope.settling[e.$key]);
        };

        $scope.isLineSettling = function (line, group) {
            return !$scope.isGroupSettling(group) && !!$scope.settling[(line.eye || line.comment).$key];
        };

        function saveFilters() {
            $scope.ShareData.waitlistFilters = {
                selectedPractices: $scope.selectedPractice,
                tab: $scope.view.tab,
                search: $scope.view.search,
                surgeon: $scope.view.surgeon,
                booking: $scope.view.booking,
                timeframe: $scope.view.timeframe,
            };
        }

        $scope.onFilterChange = function () {
            $scope.shown = PAGE_SIZE;
            rebuildList();
            saveFilters();
        };

        $scope.setTab = function (tab) {
            if ($scope.view.tab === tab) {
                return;
            }
            $scope.view.tab = tab;
            $scope.view.surgeon = "";
            $scope.onFilterChange();
        };

        $scope.setSurgeon = function (name) {
            $scope.view.surgeon = $scope.view.surgeon === name ? "" : name;
            $scope.onFilterChange();
        };

        $scope.setBooking = function (booking) {
            $scope.view.booking = booking;
            $scope.onFilterChange();
        };

        $scope.setTimeframe = function (timeframe) {
            $scope.view.timeframe = timeframe;
            $scope.onFilterChange();
        };

        $scope.hasFilters = function () {
            return !!($scope.view.search || $scope.view.surgeon
                || ($scope.view.tab === "waiting" && ($scope.view.booking || $scope.view.timeframe)));
        };

        $scope.clearFilters = function () {
            $scope.view.search = "";
            $scope.view.surgeon = "";
            $scope.view.booking = "";
            $scope.view.timeframe = "";
            $scope.onFilterChange();
        };

        $scope.sortBy = function (key) {
            if ($scope.sort.key === key && !$scope.sort.mineFirst) {
                $scope.sort.desc = !$scope.sort.desc;
            } else {
                $scope.sort = { key: key, desc: false, mineFirst: false };
            }
            rebuildList();
        };

        $scope.sortIcon = function (key) {
            if ($scope.sort.key !== key || $scope.sort.mineFirst) {
                return "fa-sort wl-sort-idle";
            }
            return $scope.sort.desc ? "fa-sort-desc" : "fa-sort-asc";
        };

        $scope.ariaSort = function (key) {
            if ($scope.sort.key !== key || $scope.sort.mineFirst) {
                return "none";
            }
            return $scope.sort.desc ? "descending" : "ascending";
        };

        $scope.showMore = function () {
            if ($scope.shown < $scope.rows.length) {
                $scope.shown += PAGE_SIZE;
            }
        };

        // =================================================================
        // Practices
        // =================================================================
        $scope.isPracticeTicked = function (id) {
            return $scope.selectedPractice.some(p => p.id === id);
        };

        // Tick to add a practice alongside the others, or untick it - every one of them, current practice
        // included, as on the calendar. With none ticked the list says so.
        $scope.togglePractice = function (practice) {
            if ($scope.isPracticeTicked(practice.id)) {
                $scope.selectedPractice = $scope.selectedPractice.filter(p => p.id !== practice.id);
            } else {
                $scope.selectedPractice = [...$scope.selectedPractice, practice];
            }
            $scope.view.surgeon = "";
            $scope.onFilterChange();
        };

        $scope.onlyPractice = function (practice) {
            $scope.selectedPractice = [practice];
            $scope.view.surgeon = "";
            $scope.onFilterChange();
        };

        // "All practices", as on the calendar: ticks every practice, and clicked again with them all ticked,
        // unticks them all.
        $scope.isEveryPracticeTicked = function () {
            return $scope.practiceOptions.every(p => $scope.isPracticeTicked(p.id));
        };

        $scope.toggleAllPractices = function () {
            $scope.selectedPractice = $scope.isEveryPracticeTicked() ? [] : $scope.practiceOptions.slice();
            $scope.view.surgeon = "";
            $scope.onFilterChange();
        };

        // Each practice's colour, as the calendar marks it: the shared palette, in order of practice id
        const practiceColours = {};
        (Session.practiceOptions || []).map(p => p.id).sort((a, b) => Number(a) - Number(b))
            .forEach((id, index) => (practiceColours[String(id)] = PRACTICE_PALETTE[index % PRACTICE_PALETTE.length]));

        $scope.practiceColour = function (practiceId) {
            return practiceColours[String(practiceId)] || PRACTICE_PALETTE[0];
        };

        $scope.practiceName = function (id) {
            const practice = $scope.practiceOptions.find(p => p.id == id);
            return practice ? practice.name : "";
        };

        // =================================================================
        // Notices beside the list
        // =================================================================
        // Only a failure is announced beside the list, and it stays until dismissed. A change that worked
        // shows on the control that made it.
        function showError(text) {
            $scope.notice = { type: "error", text: text };
        }

        $scope.dismissNotice = function () {
            $scope.notice = null;
        };

        // =================================================================
        // Saving
        // =================================================================

        // The whole entry for one eye, as it is with these changes. Only the procedure for the eye being
        // edited is sent, and the comments are that eye's.
        function requestFor(row, changes) {
            const waitlist = { ...row, ...changes };
            const request = {
                created_by_user_full_name: waitlist.surgeon_full_name,
                date_created: waitlist.surgery_waitlist_creation_date,
                patient_full_name: waitlist.patient_full_name,

                primary_procedure_od: (waitlist.laterality === "OD" ? waitlist.procedure : null),
                primary_procedure_os: (waitlist.laterality === "OS" ? waitlist.procedure : null),

                funding: waitlist.funding,
                comments: waitlist.comments,
                surgery_start_date: waitlist.surgery_start_date_UTC
                    ? moment(waitlist.surgery_start_date_UTC, "DD/MM/YYYY").toISOString()
                    : null,
                is_preapproval_submitted: waitlist.preapproval_submitted,
                is_preapproval_completed: waitlist.preapproval_completed,
                is_surgery_completed: waitlist.surgery_completed
            };
            // Sent only to a server that sent it: one that doesn't know it may refuse the field
            if (waitlist.created_by_user_id != null) {
                request.created_by_user_id = waitlist.created_by_user_id;
            }
            return request;
        }

        // Nothing changes on screen until the server has the change, so a failed save leaves the entry as
        // it really is; the control that saved shows it, and a failure is said above the list. With
        // `linger`, the row shows it worked for a moment before the list is redrawn (and a row marked
        // completed moves list).
        const settleTimers = {};

        function saveRow(row, changes, linger) {
            return $scope.surgeryWaitlistAPI.updateSurgeryWaitlist(row.patient_id, row.surgery_waitlist_id, requestFor(row, changes))
                .then((resp) => {
                    const apply = () => {
                        // The entry comes back whole, and each of its eyes takes it
                        ["OD", "OS"].forEach((laterality) => {
                            const fresh = mapToSurgeryWaitlistViewInfo(resp.data, laterality);
                            const index = fresh ? $scope.allSurgeryWaitlistViewData.findIndex((w) =>
                                w.surgery_waitlist_id === fresh.surgery_waitlist_id && w.laterality === fresh.laterality
                            ) : -1;
                            if (index !== -1) {
                                $scope.allSurgeryWaitlistViewData[index] = fresh;
                            }
                        });
                        rebuildList();
                        updateWaitlistBadgeNumber(resp.data);
                    };
                    if (linger) {
                        const key = row.$key;
                        $scope.settling[key] = true;
                        settleTimers[key] = $timeout(() => {
                            delete $scope.settling[key];
                            delete settleTimers[key];
                            apply();
                        }, 900);
                    } else {
                        apply();
                    }

                    return true;
                }, (err) => {
                    console.error("update surgery waitlist failed", err && err.status);
                    showError("That change couldn't be saved. Try again.");
                    return false;
                });
        }

        // Surgery completed - the step every eye reaches - or reopened. The button spins while it saves.
        $scope.setSurgeryCompleted = function (row, value, $event) {
            $event.stopPropagation();
            const key = row.$key;
            if ($scope.rowBusy[key] || $scope.settling[key] || !!row.surgery_completed === value) {
                return;
            }
            $scope.rowBusy[key] = value ? "done" : "reopen";
            // The eye always moves to the other tab - only it, the patient's other eyes stay where they are - so
            // it lingers and fades first.
            saveRow(row, { surgery_completed: value }, true).finally(() => {
                delete $scope.rowBusy[key];
            });
        };

        // Pre-approval submitted or completed, ticked on or off; the toggle spins while it saves
        $scope.toggleStep = function (row, step, $event) {
            $event.stopPropagation();
            const key = row.$key;
            if ($scope.rowBusy[key] || $scope.settling[key]) {
                return;
            }
            $scope.rowBusy[key] = step.field;
            saveRow(row, { [step.field]: !row[step.field] }).finally(() => {
                delete $scope.rowBusy[key];
            });
        };

        // The surgery date: the button opens the browser's own date picker on the hidden date input beside
        // it, and the date saves as soon as it is picked.
        $scope.pickSurgeryDate = function ($event, row) {
            $event.stopPropagation();
            const input = $event.currentTarget.parentNode.querySelector("input[type=date]");
            if (input && typeof input.showPicker === "function") {
                try {
                    input.showPicker();
                    return;
                } catch (e) {
                    // Not allowed here - show the input itself instead
                }
            }
            $scope.typingDate[row.$key] = true;
            $timeout(() => input && input.focus());
        };

        // "Same day as OD": this eye booked for the other eye's date
        $scope.bookSameDay = function (row) {
            const other = row.$sameDayOffer;
            if (!other || !other.$dateValue) {
                return;
            }
            row.$dateValue = new Date(other.$dateValue.getTime());
            $scope.setSurgeryDate(row);
        };

        // Booked in a practice's calendar from the row: the surgery date is the appointment's day where it was
        // booked, which need not be the practice being worked in.
        // Only ever replaces the date with the appointment's: without a day to take from it, the date already set
        // is kept rather than cleared.
        $scope.bookedInCalendar = function (row, appointment, practiceId) {
            const zone = appointment && timezoneOfPractice(appointment.practice_id || practiceId);
            const start = appointment && appointment.start_date_utc ? moment.utc(appointment.start_date_utc) : null;
            if (!zone || !start || !start.isValid()) {
                return;
            }
            row.$dateValue = moment(start.tz(zone).format("YYYY-MM-DD")).toDate();
            $scope.setSurgeryDate(row);
        };

        $scope.setSurgeryDate = function (row, clear) {
            const key = row.$key;
            const value = !clear && row.$dateValue ? moment(row.$dateValue).format("DD/MM/YYYY") : "";
            if (value === (row.surgery_start_date_UTC || "") || $scope.rowBusy[key]) {
                return;
            }
            $scope.rowBusy[key] = "date";
            delete $scope.rowSaved[key];
            saveRow(row, { surgery_start_date_UTC: value }).then((ok) => {
                delete $scope.typingDate[key];
                if (ok) {
                    $scope.rowSaved[key] = true;
                    $timeout(() => delete $scope.rowSaved[key], 2500);
                } else {
                    // The entry keeps its date; put the input back to it
                    row.$dateValue = row.surgery_start_date_UTC ? moment(row.surgery_start_date_UTC, "DD/MM/YYYY").toDate() : null;
                }
            }).finally(() => {
                delete $scope.rowBusy[key];
            });
        };

        // =================================================================
        // The surgeon: the entry's, changed on the list from the practice's clinicians, as the calendar
        // lists them
        // =================================================================
        $scope.cliniciansByPractice = {};

        function loadClinicians() {
            ($scope.practiceOptions || []).forEach((practice) => {
                const toOptions = (list) => (list || []).map(u => ({ id: u.id, name: [u.firstName, u.lastName].filter(Boolean).join(" ") }))
                    .sort((a, b) => compareText(a.name, b.name));
                const kept = ShareData.getCalendarClinicians(practice.id);
                if (kept) {
                    $scope.cliniciansByPractice[practice.id] = toOptions(kept);
                }
                AppointmentAPI.getAppointmentUsers(practice.id).then((resp) => {
                    ShareData.setCalendarClinicians(practice.id, resp.data || []);
                    $scope.cliniciansByPractice[practice.id] = toOptions(resp.data);
                }, () => {
                    // Without the list the surgeon is shown, just not changed
                });
            });
        }
        loadClinicians();

        // The practice's clinicians, with whoever has the entry first if they are not among them (no longer a
        // clinician there), so they still show as chosen
        // Made once and handed back unchanged on every digest after: ng-options tracks its options by object
        // identity, so a list with a new extra option each digest never settles - the digest runs until
        // AngularJS gives up (infdig), and the page stops updating.
        const NO_CLINICIANS = [];
        const clinicianListCache = {};

        $scope.clinicianOptions = function (row) {
            const options = $scope.cliniciansByPractice[row.practice_id] || NO_CLINICIANS;
            if (row.created_by_user_id == null || options.some(c => c.id === row.created_by_user_id)) {
                return options;
            }
            const key = row.practice_id + ":" + row.created_by_user_id;
            const kept = clinicianListCache[key];
            if (!kept || kept.options !== options || kept.name !== row.surgeon_full_name) {
                clinicianListCache[key] = {
                    options: options,
                    name: row.surgeon_full_name,
                    list: [{ id: row.created_by_user_id, name: row.surgeon_full_name }, ...options],
                };
            }
            return clinicianListCache[key].list;
        };

        // Saved as soon as it is picked, for the whole entry - both its eyes
        $scope.canChangeSurgeon = function (row) {
            return row.created_by_user_id != null && !row.$entryDone && !!$scope.cliniciansByPractice[row.practice_id];
        };

        $scope.changeSurgeon = function (row) {
            const key = row.$key;
            const id = row.$surgeonPick;
            const clinician = $scope.clinicianOptions(row).find(c => c.id === id);
            if (!clinician || id === row.created_by_user_id || $scope.rowBusy[key]) {
                row.$surgeonPick = row.created_by_user_id;
                return;
            }
            // Shown at once - on both of the entry's eyes, and wherever the list groups, sorts or filters by
            // surgeon - rather than once the server has answered; the picker marks the save meanwhile. A
            // refused change is put back.
            const before = { created_by_user_id: row.created_by_user_id, surgeon_full_name: row.surgeon_full_name };
            const change = { created_by_user_id: id, surgeon_full_name: clinician.name };
            const setEntrySurgeon = (values) => {
                $scope.allSurgeryWaitlistViewData
                    .filter(w => w.surgery_waitlist_id === row.surgery_waitlist_id)
                    .forEach(w => Object.assign(w, values));
                rebuildList();
            };
            $scope.rowBusy[key] = "surgeon";
            setEntrySurgeon(change);
            saveRow(row, change).then((ok) => {
                if (!ok) {
                    setEntrySurgeon(before);
                }
            }).finally(() => {
                delete $scope.rowBusy[key];
            });
        };

        // =================================================================
        // Comments, written on the list
        // =================================================================
        // A box that grows with what is written in it, so it is never taller or shorter than the text
        // A browser that sizes a box to its text itself (field-sizing, in the stylesheet) is left to; others are
        // measured. Either way the box starts with a row per line written, up to twelve, so it is never one
        // line high for a long text even before - or without - being measured.
        const SIZES_ITSELF = !!(window.CSS && CSS.supports && CSS.supports("field-sizing", "content"));

        function fitBox(box) {
            if (SIZES_ITSELF) {
                box.style.height = "";
                return;
            }
            box.style.height = "auto";
            box.style.height = Math.max(box.scrollHeight, box.clientHeight) + 2 + "px";
        }

        $scope.boxRows = function (text) {
            return Math.min(12, Math.max(1, String(text || "").split("\n").length));
        };

        // Focus a box opened to write in, with the cursor after what is there and the box sized to it. Done
        // straight after the digest that puts the box on the page - before the browser draws it, so it never
        // shows at the wrong height - and without the second full digest a $timeout would cost.
        function openBox(id) {
            $scope.$$postDigest(() => {
                const box = document.getElementById(id);
                if (box) {
                    fitBox(box);
                    refitOnResize(box);
                    box.focus();
                    box.setSelectionRange(box.value.length, box.value.length);
                }
            });
        }

        // The box first appears beside the comment it replaces, which ngAnimate only takes away a frame or so
        // later, so it is sized at the wrong width: too tall once it widens, or a single line if it had no
        // width yet. Sized again whenever its width changes, for as long as it is open.
        let boxObserver = null;
        function refitOnResize(box) {
            if (boxObserver) {
                boxObserver.disconnect();
                boxObserver = null;
            }
            if (typeof ResizeObserver !== "function") {
                requestAnimationFrame(() => requestAnimationFrame(() => fitBox(box)));
                return;
            }
            let width = box.clientWidth;
            const observer = new ResizeObserver(() => {
                if (!box.isConnected) {
                    observer.disconnect();
                    return;
                }
                if (box.clientWidth !== width) {
                    width = box.clientWidth;
                    fitBox(box);
                }
            });
            observer.observe(box);
            boxObserver = observer;
        }

        $scope.$on("$destroy", () => boxObserver && boxObserver.disconnect());

        function focusCommentBox(key) {
            openBox("wlComment-" + key);
        }

        $scope.fitComment = function (key) {
            const box = document.getElementById("wlComment-" + key);
            if (box) {
                fitBox(box);
            }
        };

        function commentDirty() {
            const edit = $scope.commentEdit;
            if (!edit) {
                return false;
            }
            const row = $scope.allSurgeryWaitlistViewData.find(w => rowKey(w) === edit.key);
            return (edit.text || "") !== ((row && row.comments) || "");
        }

        // Comments are the eye's, so the box is keyed by the eye row
        $scope.editComment = function (row, $event) {
            $event.stopPropagation();
            // A comment part-written on another eye is kept rather than thrown away
            if ($scope.commentEdit && $scope.commentEdit.key !== row.$key && commentDirty()) {
                focusCommentBox($scope.commentEdit.key);
                return;
            }
            $scope.commentEdit = { key: row.$key, text: row.comments || "", saving: false };
            focusCommentBox(row.$key);
        };

        $scope.cancelComment = function () {
            $scope.commentEdit = null;
        };

        $scope.saveRowComment = function (row) {
            const edit = $scope.commentEdit;
            if (!edit || edit.key !== row.$key || edit.saving || !commentDirty()) {
                return;
            }
            const key = row.$key;
            edit.saving = true;
            saveRow(row, { comments: edit.text || null }).then((ok) => {
                edit.saving = false;
                if (!ok) {
                    return;
                }
                if ($scope.commentEdit === edit) {
                    $scope.commentEdit = null;
                }
                $scope.commentSaved[key] = true;
                $timeout(() => delete $scope.commentSaved[key], 2500);
            });
        };

        // Clicking away saves what was written - or, with nothing changed, just closes the box. Moving to the
        // box's own buttons is not leaving it, and pressing them doesn't take focus from it (their mousedown is
        // stopped), so Cancel still cancels.
        $scope.onCommentBlur = function (row, $event) {
            const edit = $scope.commentEdit;
            const form = $event.target.form;
            if (!edit || edit.key !== row.$key || edit.saving || (form && $event.relatedTarget && form.contains($event.relatedTarget))) {
                return;
            }
            if (commentDirty()) {
                $scope.saveRowComment(row);
            } else {
                $scope.cancelComment();
            }
        };

        // Ctrl/Cmd + Enter saves; Escape puts the comment back, without closing the whole waitlist
        $scope.onCommentKey = function ($event, row) {
            if ($event.key === "Escape") {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.cancelComment();
            } else if ($event.key === "Enter" && ($event.ctrlKey || $event.metaKey)) {
                $event.preventDefault();
                $scope.saveRowComment(row);
            }
        };

        function updateWaitlistBadgeNumber(updatedWaitlist) {
            $scope.$emit("waitlist:updateBadge", updatedWaitlist)
        }

        // =================================================================
        // Adding an entry without a progress note
        // =================================================================
        $scope.canAddToWaitlist = Session.hasPermission("SURGERY_WAITLIST_CREATE");
        // The entry just added, marked on its row until the dialog is closed
        $scope.justAddedId = null;

        // The open patient, when an entry can be added for them here: registered at this practice and
        // already reviewed if imported. Otherwise the dialog starts with the patient search.
        function openPatientForWaitlist() {
            const open = CurrentPatient.patient;
            if (!open || !open.id || open.needs_review
                || (open.practice && open.practice.id !== Session.practice.id)) {
                return null;
            }
            return {
                id: open.id,
                name: [open.firstName, open.lastName].filter(Boolean).join(" "),
                dob: open.dateOfBirth && moment(open.dateOfBirth).isValid() ? moment(open.dateOfBirth).locale("en").format("DD/MM/YYYY") : "",
            };
        }

        // Shown above the rail's Add to waitlist button when the entry would be for the open patient
        $scope.waitlistPatientName = function () {
            const patient = openPatientForWaitlist();
            return patient ? patient.name : "";
        };

        $scope.openAddToWaitlist = function ($event) {
            $mdDialog.show({
                controller: "surgeryWaitlistAddDialogController",
                templateUrl: "app/src/views/templates/modal.surgery-waitlist-add.tpl.html",
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,
                // Over the waitlist, which stays open underneath
                multiple: true,
                // A child of this scope, so the add form's "waitlist:query" reaches the nav and the list reloads
                scope: $scope.$new(),
                preserveScope: false,
                resolve: {
                    patient: () => openPatientForWaitlist(),
                },
            }).then((surgeryWaitlistId) => {
                $scope.justAddedId = surgeryWaitlistId || null;
            }).catch(angular.noop);
        };

        $scope.isGroupJustAdded = function (group) {
            return !!$scope.justAddedId && group.eyes.some(eye => eye.surgery_waitlist_id === $scope.justAddedId);
        };

        // =================================================================
        // Opening a patient
        // =================================================================
        $scope.switchPatient = function (patientId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            if ($scope.CurrentPatient.patient.id == patientId) {
                $mdDialog.hide();
                $state.go("patient-dashboard");
                return;
            }

            $scope.patientAPI.isProcessing = true;
            $scope.patientAPI.getPatient(patientId)
                .then(
                    (resp) => {
                        let newPatient = resp.data;

                        if ($scope.CurrentPatient.patientBackup) {
                            $scope.patientBackup = angular.copy($scope.CurrentPatient.patientBackup);
                        }

                        $scope.CurrentPatient.clearPatient();
                        // $timeout, not setTimeout: setPatient/$state.go need to run inside a digest.
                        $timeout(() => {
                            $scope.CurrentPatient.setPatient(newPatient);
                            if ($scope.CurrentPatient.patientIsMine) {
                                $state.go("patient-dashboard");
                                $mdDialog.hide();
                                return;
                            }

                            // Launch the new standalone transfer modal
                            $modal({
                                controller: "patientTransferController",
                                templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
                                show: true,
                                backdrop: "static",
                                resolve: {
                                    patientId: function () {
                                        return newPatient.id;
                                    },
                                    onSuccess: function () {
                                        return function (updatedPatient) {
                                            $scope.CurrentPatient.setPatient(updatedPatient);
                                            $state.go("patient-dashboard");
                                            $mdDialog.hide();
                                        };
                                    },
                                    onCancel: function () {
                                        return function () {
                                            // Restore the backup if they cancel
                                            if ($scope.patientBackup) {
                                                $scope.CurrentPatient.setPatient($scope.patientBackup);
                                            }
                                        };
                                    }
                                }
                            });
                        }, 0);
                    },
                    () => {
                        // Revert to backup on fetch error
                        if ($scope.patientBackup) {
                            $scope.CurrentPatient.setPatient($scope.patientBackup);
                        }
                        showError("That patient couldn't be opened. Try again.");
                    }
                )
                .then(() => {
                    $scope.patientAPI.isProcessing = false;
                });
        };

        $scope.$on("$destroy", function () {
            Object.keys(settleTimers).forEach(key => $timeout.cancel(settleTimers[key]));
        });
    },
]);
